// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-module--badge--1sdeQ","inactive":"badge-module--inactive--1KZve","skeletonmargin":"badge-module--skeletonmargin--1RDDo"};